<ng-select
  [items]="baseItems()"
  [ngModel]="selectedItems()"
  (ngModelChange)="onChange($event)"
  (blur)="onBlur()"
  bindLabel="listName"
  groupBy="parentGrouping"
  [placeholder]="placeholder()"
  [loading]="loading()"
  [loadingText]="loadingText()"
  notFoundText="{{ 'multiSelectNotFound' | i18n }}"
  clearAllText="{{ 'multiSelectClearAll' | i18n }}"
  [multiple]="true"
  [closeOnSelect]="false"
  (close)="onDropdownClosed()"
  [disabled]="disabled()"
  [clearSearchOnAdd]="true"
  [labelForId]="searchInputId()"
  [keyDownFn]="keyDown"
  appendTo="body"
  outsideClickEvent="mousedown"
>
  <ng-template ng-loadingspinner-tmp>
    <bit-spinner size="sm" />
  </ng-template>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <bit-chip
      size="small"
      class="tw-me-1"
      [label]="item.labelName"
      [startIcon]="item.icon"
      [disabled]="disabled()"
      (dismissed)="clear(item)"
    ></bit-chip>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="tw-flex tw-items-center">
      <div class="tw-w-7 tw-flex-none">
        @if (isSelected(item)) {
          <bit-icon name="bwi-check" aria-hidden="true"></bit-icon>
        }
      </div>
      <div class="tw-me-2 tw-flex-initial">
        @if (item.iconTile) {
          <!-- tw-flex on the host: its inner box is inline-flex, so an inline host would add a line
               box's worth of descender space below the tile and push it above the row's center. -->
          <bit-icon-tile
            class="!tw-flex"
            [icon]="item.iconTile.icon"
            [variant]="item.iconTile.variant ?? 'primary'"
            [color]="item.iconTile.color"
            [emphasis]="item.iconTile.emphasis ?? 'subtle'"
            size="xs"
          />
        } @else if (item.icon != null) {
          <i class="bwi bwi-fw {{ item.icon }}" aria-hidden="true"></i>
        }
      </div>
      <div class="tw-flex-1" [attr.title]="item.listName">
        {{ item.listName }}
      </div>
    </div>
  </ng-template>
</ng-select>
